import React from 'react';
import { Route } from 'react-router-dom';

export default ({ routes, roleProp, user }) => (
  <div>
    {routes.map((route, index) => (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        render={props => <route.component {...props} client={route.client} roleProp={roleProp} user={user} />}
      />
    ))}
  </div>
);
